<script>
  import pessoaServico from '~modulos/pessoa/servico';
  import Carregando from '~componentes/Carregando.vue';
  import AdicionarArquivos from '~componentes/FormAdicionarArquivos.vue';
  import ListaDeArquivos from '~componentes/ListaDeArquivos.vue';
  import DadosCadastrais from './compartilhado/FormDadosCadastrais.vue';
  import DadosContatos from './compartilhado/FormDadosContatos.vue';
  import DadosBancarios from './compartilhado/FormDadosBancarios.vue';
  import Socios from './compartilhado/FormSocios.vue';
  import Certidoes from './compartilhado/FormCertidoes.vue';
  import Atividades from './compartilhado/FormAtividades.vue';
  import DueDiligence from './compartilhado/FormDueDiligence.vue';
  import ResumoAceite from './compartilhado/FormResumoAceite.vue';
  
  export default {
    components: {
      Carregando, DadosCadastrais, DadosContatos, DadosBancarios, Socios,
      Certidoes, Atividades, DueDiligence, ResumoAceite,
      AdicionarArquivos, ListaDeArquivos
    },
    data() {
      return {
        configuracao: this.$storage.configuracao(),
        carregando: true,
        arquivos: [],
        arquivosNaoSalvos: [],
        arquivosCertidoes: [],
        habilitarDUEDiligence: false,
        habilitarFormResumoAceite: true,
        fornecedor: {
          nomePessoaFisicaJuridica: '',
          nomeFantasia: '',
          endereco: '',
          bairro: '',
          cidade: '',
          estado: '',
          cep: '',
          cpfCnpj: '',
          identidadeInscEstadual: '',
          carteiraTrabalhoInscMunicipal: '',
          telefone1: '',
          telefone2: '',
          fax: '',
          contato: '',
          cargoFinanceiro: '',
          telContatoFinanceiro: '',
          email: '',
          contatoCompras: '',
          cargoCompras: '',
          telContatoCompras: '',
          emailCompras: '',
          emailPesquisa: '',
          dataAlteracaoAcessoWeb: '',
          tipoPessoaFisicaJuridica: '',
          pagamentoBoleto: false,
          dadosBancarios: [],
          socios: [],
          certidoes: [],
          atividades: [],
          formRespostasFornecedor: [],
          formRespostasParticipacaoAcionaria: [],
          formRespostasRelacaoContratual: [],
          formRespostasEmpresaReferencia: [],
          formRespostasRelacaoFundacao: [],
        },
      }
    },
    mounted() {
      this.$root.tituloDaPagina = 'Alterar cadastro';

      this.$root.botaoAcaoMostrar = false;
      
      this.carregar();
    },
    methods: {
      mostrarConfirmacaoAlteracaoFornecedor() {
        if (!this.configuracao.alteracaoFornecedorConfirmacao) return;

        this.$swal({
          title: 'Alteração de Informações',
          html: this.configuracao.alteracaoFornecedorConfirmacao.replace(/\r\n/g, '<br>'),
          type: 'info',
          confirmButtonText: 'Ok, entendi!',
          allowOutsideClick: false,
          allowEscapeKey: false,
        });
      },
      salvar() {
        $('#salvar').button('loading');

       this.$refs.dadosCadastrais.validar(true)
          .then(valido => {
            if (!valido) {
              $('#tabs a[href="#tab-dados-cadastrais"]').tab('show');
            }

            return valido;
          })
          .then(this.$refs.dadosContatos.validar)
          .then(valido => {
            if (!valido) {
              $('#tabs a[href="#tab-dados-contatos"]').tab('show');
            }

            return valido;
          })
          .then((valido) => {
            return this.habilitarFormResumoAceite
              ? this.$refs.resumoAceite.validar(valido)
              : true;
          })
          .then(valido => {
            if (!valido) {
              $('#tabs a[href="#tab-resumo-aceite"]').tab('show');
            }

            return valido;
          })
          .then((valido) => {
            if (!valido) throw new Error("validacao com erro");
            return this.habilitarDUEDiligence
              ? this.$refs.dueDiligence.validar(valido)
              : true;
          })
          .then(valido => {
            if (!valido) {
              $('#tabs a[href="#tab-due-diligence"]').tab('show');
            }

            return valido;
          })
          .then(this.enviar)
          .then(dados => {

            $('#salvar').button('reset');

            toastr.success(`Dados alterados com sucesso.`);

            this.$refs.listaArquivos.deletados = [];
            this.$refs.adicionarArquivos.limparArquivos();

            this.carregar();

          })
          .catch(erro => {

            $('#salvar').button('reset');

            this.$mensagemErro(erro);
          });

        this.mostrarConfirmacaoAlteracaoFornecedor();
      },
      enviar(valido) {

        if (!valido) throw new Error("validacao com erro");

        this.$set(this.fornecedor, 'arquivosDeletados', this.$refs.listaArquivos.deletados)
        this.fornecedor.pessoaFisicaJuridicaResumoAceite = [this.$refs.resumoAceite.gerarObjetoDeDados()]
        const arquivos = this.$refs.adicionarArquivos.arquivos;
        const arquivosCertidao = this.$refs.certidoes.arquivosCertidoes;

        return pessoaServico.alterarFornecedor(this.fornecedor, arquivos, arquivosCertidao);
      },
      download(arquivo) {
        pessoaServico
          .download(this.fornecedor.idPessoaFisicaJuridica, arquivo)
          .then(arquivo => {
            arquivo.download();
          });
      },
      downloadCertidao(idCertidaoPessoa, arquivoCertidao) {
        pessoaServico
          .downloadCertidao(idCertidaoPessoa, arquivoCertidao)
          .then(arquivo => {
            arquivo.download();
          });
      },
      carregar() {
        this.carregando = true;
        
        return pessoaServico
          .fornecedor()
          .then(dados => {

            this.fornecedor = dados;

            this.habilitarDUEDiligence = this.configuracao.habilitarDUEDiligence
              && this.fornecedor.habilitarDUEDiligence;

          })
          .then(() => pessoaServico.arquivos(this.fornecedor.idPessoaFisicaJuridica))
          .then(arquivos => {
            this.arquivos = arquivos;
          })
          .then(() => {
            this.carregando = false;
          });
      },
    },
  }
</script>

<template>
  <div>

    <form @submit.prevent="">

      <carregando v-if="carregando"></carregando>

      <div class="tabs-container" v-show="!carregando" id="tabs">

        <ul class="nav nav-tabs">
          <li class="active">
            <a data-toggle="tab"
               href="#tab-dados-cadastrais">
              Dados cadastrais
            </a>
          </li>
          <li>
            <a data-toggle="tab"
               href="#tab-dados-contatos">
              Contatos
            </a>
          </li>
          <li>
            <a data-toggle="tab"
               href="#tab-dados-bancarios">
              Dados bancários
            </a>
          </li>
          <li>
            <a data-toggle="tab"
               href="#tab-socios">
              Sócios
            </a>
          </li>
          <li>
            <a data-toggle="tab"
               href="#tab-certidoes">
              Certidões
            </a>
          </li>
          <li>
            <a data-toggle="tab"
               href="#tab-atividades">
              Atividades
            </a>
          </li>
          <li v-if="habilitarDUEDiligence">
            <a data-toggle="tab"
               href="#tab-due-diligence">
              DUE DILIGENCE
            </a>
          </li>
          <li>
            <a data-toggle="tab"
               href="#tab-adicionar-arquivos">
              Adicionar arquivos
            </a>
          </li>
          <li>
            <a data-toggle="tab"
               href="#tab-arquivos">
              Arquivos
            </a>
          </li>
          <li v-if="habilitarFormResumoAceite">
            <a data-toggle="tab"
               href="#tab-resumo-aceite">
              Resumo e aceite
            </a>
          </li>
        </ul>

        <div class="tab-content">
          <div id="tab-dados-cadastrais" class="tab-pane active">
            <div class="panel-body">
              <dados-cadastrais ref="dadosCadastrais"
                                :fornecedor="fornecedor"
                                :carregando="carregando">
              </dados-cadastrais>
            </div>
          </div>

          <div id="tab-dados-contatos" class="tab-pane">
            <div class="panel-body">
              <dados-contatos ref="dadosContatos"
                              :fornecedor="fornecedor">
              </dados-contatos>
            </div>
          </div>

          <div id="tab-dados-bancarios" class="tab-pane">
            <div class="panel-body">
              <dados-bancarios ref="dadosBancarios"
                               :dadosBancarios="fornecedor.dadosBancarios">
              </dados-bancarios>
            </div>
          </div>

          <div id="tab-socios" class="tab-pane">
            <div class="panel-body">
              <socios ref="socios"
                      :socios="fornecedor.socios">
              </socios>
            </div>
          </div>

          <div id="tab-certidoes" class="tab-pane">
            <div class="panel-body">
              <certidoes ref="certidoes"
                         :certidoes="fornecedor.certidoes"
                         @downloadCertidao="downloadCertidao"
                         :arquivosCertidoes="arquivosCertidoes">
              </certidoes>
            </div>
          </div>

          <div id="tab-atividades" class="tab-pane">
            <div class="panel-body">
              <atividades ref="atividades"
                          :atividades="fornecedor.atividades">
              </atividades>
            </div>
          </div>

          <div id="tab-due-diligence" class="tab-pane" v-if="habilitarDUEDiligence">
            <div class="panel-body">
              <due-diligence ref="dueDiligence"
                             :formRespostasFornecedor="fornecedor.formRespostasFornecedor"
                             :formRespostasParticipacaoAcionaria="fornecedor.formRespostasParticipacaoAcionaria"
                             :formRespostasRelacaoContratual="fornecedor.formRespostasRelacaoContratual"
                             :formRespostasEmpresaReferencia="fornecedor.formRespostasEmpresaReferencia"
                             :formRespostasRelacaoFundacao="fornecedor.formRespostasRelacaoFundacao"
                             :habilitarDUEDiligence="habilitarDUEDiligence">
              </due-diligence>
            </div>
          </div>

          <div id="tab-adicionar-arquivos" class="tab-pane">
            <div class="panel-body">
              <adicionar-arquivos ref="adicionarArquivos" v-model="arquivosNaoSalvos">
              </adicionar-arquivos>
            </div>
          </div>

          <div id="tab-arquivos" class="tab-pane">
            <div class="panel-body">
              <lista-de-arquivos :arquivos="arquivos"
                                 @download="download"
                                 ref="listaArquivos">
              </lista-de-arquivos>
            </div>
          </div>

          <div id="tab-resumo-aceite" class="tab-pane">
            <div class="panel-body">
              <resumo-aceite ref="resumoAceite"
                             :fornecedor="fornecedor"
                             :arquivos="arquivos"
                             :arquivosNaoSalvos="arquivosNaoSalvos">
              </resumo-aceite>
            </div>
          </div>
        </div>

      </div>

      <div class="row" v-show="!carregando">
        <div class="col-xs-9">
          <div class="form-group">
            <router-link
              class="btn btn-default"
              :to="{ name: 'home' }"
              active-class="">
              <i class="fa fa-arrow-left"></i>
              Voltar
            </router-link>

            <button
              id="salvar"
              type="button"
              class="btn btn-primary"
              @click="salvar"
              data-loading-text="<i class='fa fa-spinner fa-pulse'></i> Salvando...">
              <i class="fa fa-save"></i>
              Salvar
            </button>
          </div>
        </div>
        <div class="col-xs-9">
          <span class="time-right" v-if="fornecedor.dataAlteracaoAcessoWeb">
            Última atualização realizada em {{fornecedor.dataAlteracaoAcessoWeb | formatarData }} às {{fornecedor.dataAlteracaoAcessoWeb | formatarHora }}
          </span>
        </div>
      </div>
      
    </form>
    
  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/fornecedor/componentes/Alterar.vue